import { ActionReducerMap } from '@ngrx/store';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { authReducer, AuthState } from './auth/auth.reducer';
import { toastFeature } from './toast/toast.reducer';
import { userAuthReducer, UserAuthState } from './user/auth/user-auth.reducer';
import { AuthEffects } from './auth/auth.effects';
import { UserAuthEffects } from './user/auth/user-auth.effects';
import { ToastEffects } from './toast/toast.effects';
import {
  masterScheduleReducer,
  MasterScheduleState,
} from './master-schedule/master-schedule.reducer';
import { MasterScheduleEffects } from './master-schedule/master-schedule.effects';
import { schedulerCrewReducer, SchedulerCrewState } from './scheduler-crew/scheduler-crew.reducer';
import { SchedulerCrewEffects } from './scheduler-crew/scheduler-crew.effects';
import {
  dailyLineScheduleReducer,
  DailyLineScheduleState,
} from './daily-line-schedule/daily-line-schedule.reducer';
import { DailyLineScheduleEffects } from './daily-line-schedule/daily-line-schedule.effects';
import { fixedWingReducer, FixedWingState } from './fixed-wing/fixed-wing.reducer';
import { FixedWingEffects } from './fixed-wing/fixed-wing.effects';
import {
  baseManagementReducer,
  BaseManagementState,
} from './base-management/base-management.reducer';
import { BaseManagementEffects } from './base-management/base-management.effects';
import { attendanceLogReducer, AttendanceLogState } from './attendance-log/attendance-log.reducer';
import { AttendanceLogEffects } from './attendance-log/attendance-log.effects';

export interface AppState {
  router: RouterReducerState;
  auth: AuthState;
  userAuth: UserAuthState;
  masterSchedule: MasterScheduleState;
  schedulerCrew: SchedulerCrewState;
  dailyLineSchedule: DailyLineScheduleState;
  fixedWing: FixedWingState;
  baseManagement: BaseManagementState;
  attendanceLog: AttendanceLogState;
}

export const appReducers: ActionReducerMap<AppState> = {
  router: routerReducer,
  auth: authReducer,
  [toastFeature.name]: toastFeature.reducer,
  userAuth: userAuthReducer,
  masterSchedule: masterScheduleReducer,
  schedulerCrew: schedulerCrewReducer,
  dailyLineSchedule: dailyLineScheduleReducer,
  fixedWing: fixedWingReducer,
  baseManagement: baseManagementReducer,
  attendanceLog: attendanceLogReducer,
} as ActionReducerMap<AppState>;

export const appEffects = [
  AuthEffects,
  UserAuthEffects,
  ToastEffects,
  MasterScheduleEffects,
  SchedulerCrewEffects,
  DailyLineScheduleEffects,
  FixedWingEffects,
  BaseManagementEffects,
  AttendanceLogEffects,
];
